var usePaymentConfirmation = function (policyId, dispatch, policyConfirm) {
    var handleSendEmail = function (email) {
        var body = {
            id: policyId,
            includeAttachments: false,
            ccEmail: [email],
        };
        dispatch(policyConfirm(body));
    };
    return {
        handleSendEmail: handleSendEmail,
    };
};
export default usePaymentConfirmation;
